const TLDS = require('../constants/top-level-domain-extensions');
const WEB_EXTS = require('../constants/web-extensions');
const EXTS = [...TLDS, ...WEB_EXTS];

const getUrlExtension = (url) => {
  let ext = url.split(/[#?]/)[0].split('.').pop().trim();
  const reg = ext ? ext.match(/^(.*?)\//, '') : null;
  if (reg && reg[1]) {
    ext = reg[1];
  }
  return ext ? ext.toUpperCase() : ext;
};

module.exports = function (value) {
  return value
    .map(({ key, url, originalPath }) => {
      if (key && key.length) {
        // if we have original path, check to see if we're trying to handle
        // a direct URL instead of a file url
        if (originalPath) {
          const ext = getUrlExtension(originalPath);
          if (EXTS.includes(ext)) {
            return encodeURI(originalPath);
          }
        }

        // @NOTE: This is the content.lennd.com cloudfront
        return encodeURI(`https://d2zsryopbdog7m.cloudfront.net/${key}`);
      }

      return url;
    })
    .join('\n');
};
